export default "__VITE_ASSET__CsU99Vae__"